<template>
  <v-row class="ma-0" >
    <v-col align="center" style="width: 490px;font-size: 13px">
      <v-card class="new-card pa-10 elevation-10" align="left">
        <div class="text-center mb-4">
          <img class="logo" src="@/assets/img/header_logo.png" alt="新学社">
        </div>
        <h2 class="text-center mb-6">アカウント登録が完了しました。</h2>
        <p class="message mb-6">下のアカウント情報ダウンロードボタンより、アカウント情報が記載されたEXCELファイルがダウンロードが可能です。</p>
        <p class="message mb-6">
          ご登録いただいたメールアドレス宛にも同内容のファイルを送付しておりますが、
          アドレスの入力誤り等で、メールが送付できていない場合もございますので、
          こちらの画面でも必ずEXCELファイルのダウンロードをお願いいたします。
        </p>
        <p class="message mb-6">ファイルのダウンロードが完了しましたら、下記からログインをお願いいたします。</p>
        <div class="text-center mb-4">
          <v-btn color="primary" @click="downloadExcel" :loading="downloading">
            <v-icon left>mdi-file-excel</v-icon>
            アカウント情報ダウンロード
          </v-btn>
        </div>
        <p class="message mb-6">
          ログイン URL：<a :href="loginUrl" target="_blank" rel="noopener noreferrer">{{ loginUrl }}</a>
        </p>
        <v-simple-table class="mb-6">
          <template v-slot:default>
            <thead>
              <tr>
                <th>ID</th>
                <th>パスワード</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, index) in registeredUsers" :key="index">
                <td>{{ user.login }}</td>
                <td>{{ user.password }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { saveAs } from 'file-saver'

export default {
  data() {
    return {
      downloading: false
    }
  },
  computed: {
    registeredUsers() {
      return this.$store.state.school.registeredUsers
    },
    registeredSchoolId() {
      return this.$store.state.school.registeredSchoolId
    },
    loginUrl() {
      return `${window.location.origin}/sign_in`
    }
  },
  created() {
    if (!this.registeredUsers || this.registeredUsers.length === 0) {
      this.$router.push('/enrollment/auth')
    }
  },
  beforeDestroy() {
    this.$store.commit('school/clearRegisteredUsers')
  },
  methods: {
    async downloadExcel() {
      if (!this.registeredSchoolId) return
      this.downloading = true
      try {
        const userIds = this.registeredUsers.map(u => u.id)
        const res = await this.$axios.get(`/api/v1/schools/${this.registeredSchoolId}/download_accounts`, {
          params: { user_ids: userIds },
          responseType: 'blob'
        })
        const blob = new Blob([res.data], { type: res.data.type })
        const contentDisposition = res.headers['content-disposition']
        let fileName = 'アカウント一覧.xlsx'
        if (contentDisposition) {
          const match = contentDisposition.substring(contentDisposition.indexOf("''") + 2)
          fileName = decodeURI(match).replace(/\+/g, ' ')
        }
        saveAs(blob, fileName)
      } catch (e) {
        this.$toasted.global.error({ message: 'ダウンロードに失敗しました' })
      } finally {
        this.downloading = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.row
  height 100%

.logo
  margin-right 18px

.new
  &-card
    max-width 1000px

h2
  color #2d5aa3
  font-weight bold
  font-size 22px

.message
  font-size 14px
</style>
